const prefix = `hendrx_theme_`;

export const ThemeClassNames = {
  page: `${prefix}page`,
  stage: `${prefix}stage`
};

function getObjectValuesDeep(obj: Record<string, unknown>): string[] {
  const strings = [];

  for (const key in obj) {
    if (typeof obj[key] === 'string') {
      strings.push(obj[key]);
    } else if (typeof obj[key] === 'object') {
      strings.push(...getObjectValuesDeep(obj[key] as Record<string, unknown>));
    }
  }

  return strings;
}

export const ThemeClassNamesStringList = getObjectValuesDeep(ThemeClassNames);
